import { MouseEvent, ReactNode, useState } from "react";
import { ListItemText, Menu, MenuItem } from "@mui/material";

import { Link } from "react-router-dom";

export type LinkData = {
  name: string;
  current: boolean;
  href?: string;
  onClick?: () => void;
};

export type MenuButtonProps = {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  children?: ReactNode;
};

type LinkMenuProps = {
  links: LinkData[];
  Button: (props: MenuButtonProps) => ReactNode;
  children?: ReactNode;
};

export function LinkMenu({ Button, links, children }: LinkMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  if (links.length === 0) {
    return null;
  }

  const onClick = (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);

  return (
    <>
      <Button onClick={onClick}>{children}</Button>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {links.map((link) =>
          link.href ? (
            <MenuItem
              key={link.name}
              disableRipple
              component={Link}
              onClick={() => setAnchorEl(null)}
              to={link.href}
            >
              <ListItemText>{link.name}</ListItemText>
            </MenuItem>
          ) : (
            <MenuItem
              key={link.name}
              disableRipple
              onClick={() => {
                link.onClick?.();
                setAnchorEl(null);
              }}
            >
              <ListItemText>{link.name}</ListItemText>
            </MenuItem>
          ),
        )}
      </Menu>
    </>
  );
}
